var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geofence-empty-screen"},[_c('div',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.$t("geofence.emptyListSuggestion"))+"\n  ")]),_c('base-button',{staticClass:"ok-button",attrs:{"color":"primary","rounded":false},on:{"click":_vm.okBtnHandler}},[_vm._v("\n      "+_vm._s(_vm.$t("ok"))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }